import axios from 'axios';
import { FilterSelectedValue } from '../hooks/filters/interfaces/filter-selected-value.interface';

const API_URL = process.env.REACT_APP_API_URL;
interface EncodedFilterSelection {
  encoded: string;
}
interface DecodedFilterSelection {
  decoded: string;
}
export const postEncodeFilterSelection = async (
  filterSelection: FilterSelectedValue[],
): Promise<EncodedFilterSelection> => {
  const decoded = JSON.stringify(filterSelection);
  const data: EncodedFilterSelection = (
    await axios.post(`${API_URL}filters/encode`, { decoded })
  ).data;

  return data;
};

export const postDecodeFilterSelection = async (
  encoded: string,
): Promise<FilterSelectedValue[]> => {
  const data: DecodedFilterSelection = (
    await axios.post(`${API_URL}filters/decode`, { encoded })
  ).data;
  if (data.decoded === null) {
    return [];
  }

  try {
    const filterSelection: FilterSelectedValue[] = JSON.parse(data.decoded);
    return filterSelection;
  } catch (e) {
    if (e instanceof Error) throw e;
    return [];
  }
};
